import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

import * as types from './score.types';
import * as constants from './score.constants';

export const storeScore = generateStoreResourceAction<types.IScore>(constants.STORE_SCORE);
export const clearScore = generateClearResourceAction(constants.CLEAR_SCORE);
